/* eslint-env browser */
import Axios from 'axios'
import * as React from 'react'

import { BoundariesFullList } from './hydro/BoundariesFullList'
import { BusinessesFullList } from './hydro/BusinessesFullList'
import { CatchMethodsFullList } from './hydro/CatchMethodsFullList'
import { HydroInfos } from './hydro/HydroInfos'
import { SpeciesFullList } from './hydro/SpeciesFullList'
import { WatersFullList } from './hydro/WatersFullList'
import { FishingTrailsFullList } from './hydro/FishingTrailsFullList'
import { FishingTrailInfos } from './hydro/FishingTrailInfos'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const CatchesGrid = require('./CatchesGrid/Grid')
const BestGearPage = require('./Gear/BestGearPage')
const GearsByCategory = require('./Gear/GearsByCategory')
const GearsBySpecies = require('./Gear/GearsBySpecies')
const FilteredGearGrid = require('./Gear/FilteredGearGrid')
const UsersGrid = require('./UsersGrid/Grid')
const EmptyData = require('./EmptyData')
const UserCatchesMap = require('./Maps/UserCatchesMap')
const ArrayModal = require('./Modals/ArrayModal')

const PubSub = require('../../../client/clientjs/services/pub-sub')

/* eslint react/destructuring-assignment:0 */
/* eslint react/prop-types:0 */

const COMPONENTS = {
  raw: props => (
    <div className="content">
      <div className="animated fadeIn faster" dangerouslySetInnerHTML={{ __html: props.content }} />
    </div>
  ),
  catchesGrid: (props, appConfig, shortLocaleIdentifier, { onShowArrayModal }) => (
    <div className="animated fadeIn faster">
      <CatchesGrid
        userSettings={appConfig.userSettings}
        locale={appConfig.locale.identifierShort}
        isLoggedIn={appConfig.isLoggedIn}
        catches={props.catches || []}
        displayLikes={props.displayLikes}
        loadMore={props.loadMore}
        showArrayModal={onShowArrayModal}
      />
    </div>
  ),
  bestGears: (props, appConfig) => (
    <div className="animated fadeIn faster">
      <BestGearPage appConfig={appConfig} gears={props.gears} />
    </div>
  ),
  gearsByCategories: (props, appConfig) => (
    <div className="animated fadeIn faster">
      <GearsByCategory appConfig={appConfig} gears={props.gears} />
    </div>
  ),
  gearBySpecies: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <GearsBySpecies
        locale={shortLocaleIdentifier}
        bestSpeciesWithGear={props.bestSpeciesWithGear}
        productCategories={props.productCategories}
        permanentFilters={props.permanentFilters}
        sortBy={props.sortBy}
        productCategoriesIds={props.productCategoriesIds}
        host={appConfig.config.host}
        hostPath={path}
        moreGearTargetPath={props.moreGearTargetPath}
      />
    </div>
  ),
  usersGrid: (props, appConfig) => (
    <div className="animated fadeIn faster">
      <UsersGrid customItemClassName="is-3-mobile is-3-tablet is-2-desktop" appConfig={appConfig} users={props.users} />
    </div>
  ),
  userCatchesMap: (props, appConfig, shortLocaleIdentifier) => (
    <div className="animated fadeIn faster">
      <UserCatchesMap locale={shortLocaleIdentifier} appConfig={appConfig} {...props} />
    </div>
  ),
  filteredGearGrid: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <FilteredGearGrid locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  boundariesList: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <BoundariesFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  watersList: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <WatersFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  hydroSpecies: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <SpeciesFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  fishingTrailsList: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <FishingTrailsFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  businesses: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <BusinessesFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  hydroCatchMethods: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <CatchMethodsFullList locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  hydroInfos: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <HydroInfos locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
  fishingTrailDetails: (props, appConfig, shortLocaleIdentifier, { path }) => (
    <div className="animated fadeIn faster">
      <FishingTrailInfos locale={shortLocaleIdentifier} host={appConfig.config.host} hostPath={path} {...props} />
    </div>
  ),
}

class ScrollableCoverContent extends React.Component {
  constructor(props) {
    super(props)
    let currentlySelectedIdx = (props.tabs || []).findIndex(tab => tab.isActive)
    if (currentlySelectedIdx === -1) {
      currentlySelectedIdx = 0
    }
    this.state = {
      tabs: props.tabs || [],
      currentlySelectedIdx,
      loadingDistantProps: {}, // object corresponding to tabs keys
      arrayModalOpts: { isActive: false },
    }
    this.loadDistantProps = this.loadDistantProps.bind(this)
    this.onShowArrayModal = this.onShowArrayModal.bind(this)
    this.onHideArrayModal = this.onHideArrayModal.bind(this)
    this.loadDistantProps()
  }

  componentDidMount() {
    this.eventId = PubSub.sub('scrollableCoverTabClick', ({ event, args }) => {
      const { tabs } = this.state
      const newIdx = (tabs || []).findIndex(tab => tab.key === args.tabKey)
      this.setState({ currentlySelectedIdx: newIdx }, this.loadDistantProps)
    })
  }

  componentWillUnmount() {
    PubSub.unsub('scrollableCoverTabClick', this.eventId)
  }

  onShowArrayModal(arrayModalOpts) {
    this.setState({ arrayModalOpts })
  }

  onHideArrayModal() {
    this.setState({ arrayModalOpts: { isActive: false } })
  }

  loadDistantProps() {
    const { tabs, currentlySelectedIdx, loadingDistantProps } = this.state
    const tabToRender = tabs[currentlySelectedIdx]

    if (!tabToRender) {
      return
    }
    if (tabToRender.remotePropsLoadingPath) {
      const distantProps = loadingDistantProps[tabToRender.key]
      if (distantProps && distantProps.status) {
        return
      }
      this.setState(
        prevState => ({
          loadingDistantProps: { ...prevState.loadingDistantProps, [tabToRender.key]: { status: 'LOADING' } },
        }),
        () => {
          Axios.get(`/api/renderProps/${tabToRender.remotePropsLoadingPath}`)
            .then(response => {
              this.setState(prevState => ({
                loadingDistantProps: {
                  ...prevState.loadingDistantProps,
                  [tabToRender.key]: { status: 'DONE', props: response.data || {} },
                },
              }))
            })
            .catch(() => {
              this.setState(prevState => ({
                loadingDistantProps: { ...prevState.loadingDistantProps, [tabToRender.key]: { status: 'DONE' } },
              }))
            })
        }
      )
    }
  }

  render() {
    const { tabs, currentlySelectedIdx, loadingDistantProps, arrayModalOpts } = this.state
    const { appConfig } = this.props
    const tabToRender = tabs[currentlySelectedIdx]

    if (!tabToRender || !tabToRender.type) {
      return <div />
    }

    if (tabToRender.isEmpty && tabToRender.emptyTexts) {
      return (
        <EmptyData
          emptyableId={tabToRender.emptyableId}
          title={tabToRender.emptyTexts.title}
          subtitle={tabToRender.emptyTexts.subtitle}
          cta={tabToRender.emptyTexts.cta}
        />
      )
    }

    const componentToRender = COMPONENTS[tabToRender.type]
    if (!componentToRender) {
      return <div />
    }

    let isLoading = false
    let remoteProps = {}
    if (tabToRender.remotePropsLoadingPath) {
      const distantProps = loadingDistantProps[tabToRender.key]
      isLoading = !distantProps || distantProps.status === 'LOADING'
      if (distantProps) {
        remoteProps = distantProps.props || {}
      }
    }
    if (isLoading) {
      return <div className="loader is-size-1 is-primary is-large is-self-centered" />
    }

    return [
      <div key="content-card" className="content-card">
        {tabToRender.longTitle && (
          <h2 className="title is-size-5">
            {tabToRender.icon && (
              <span className="icon is-size-7">
                <i className={classNames('fas', [tabToRender.icon])} aria-hidden="true">
                  &nbsp;
                </i>
              </span>
            )}
            {tabToRender.longTitle}
          </h2>
        )}
        {tabToRender.contentIntroduction && <div className="content">{tabToRender.contentIntroduction}</div>}
        {componentToRender(
          {
            ...tabToRender.props,
            ...remoteProps,
          },
          appConfig,
          appConfig.locale.identifierShort,
          {
            path: tabToRender.path,
            onShowArrayModal: this.onShowArrayModal,
          }
        )}
      </div>,
      tabToRender.props.moreButton ? (
        <div key="moreLink" className="column is-12 has-padding-small has-text-centered">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={tabToRender.props.moreButton.targetUrl}
            className="button is-call-to-action"
            title={tabToRender.props.moreButton.title}
          >
            {tabToRender.props.moreButton.title}
          </a>
        </div>
      ) : null,
      <ArrayModal
        key="arrayModal"
        locale={appConfig.locale.identifierShort}
        onHide={this.onHideArrayModal}
        isLoggedIn={appConfig.isLoggedIn}
        userSettings={appConfig.userSettings}
        host={appConfig.config.host}
        {...arrayModalOpts}
      />,
    ]
  }
}

ScrollableCoverContent.propTypes = {
  tabs: PropTypes.array.isRequired,
  appConfig: PropTypes.object.isRequired,
}

ScrollableCoverContent.defaultProps = {}

module.exports = ScrollableCoverContent
